<template>
  <div>
    <v-alert
      @input="onClose"
      :value="true"
      border="left"
      close-text="Inchideti"
      color="error"
      dark
      dismissible
    >
      {{ text }}
    </v-alert>
  </div>
</template>
<script>
export default {
  props: ["text"],
  methods: {
    onClose() {
      this.$emit("dismissed");
    }
  }
};
</script>
